export const formatPriceValue = (value: number): { value: string; unit: string } => {
  if (value >= 1000000000) {
    return { value: (value / 1000000000).toLocaleString('ru-RU', { maximumFractionDigits: 2 }), unit: 'млрд' };
  }
  if (value >= 1000000) {
    return { value: (value / 1000000).toLocaleString('ru-RU', { maximumFractionDigits: 2 }), unit: 'млн' };
  }
  if (value >= 1000) {
    return { value: (value / 1000).toLocaleString('ru-RU', { maximumFractionDigits: 2 }), unit: 'тыс' };
  }

  return { value: value.toLocaleString('ru-RU', { maximumFractionDigits: 2 }), unit: '' };
};

export const getPriceButtonText = (
  gte: string | number | undefined,
  lte: string | number | undefined,
  isPricePerMeter: boolean,
): string => {
  const gteNum = typeof gte === 'string' ? parseFloat(gte) : (gte ?? 0);
  const lteNum = typeof lte === 'string' ? parseFloat(lte) : (lte ?? 0);
  const hasGte = !isNaN(gteNum) && gteNum > 0;
  const hasLte = !isNaN(lteNum) && lteNum > 0;

  if (!hasGte && !hasLte) {
    return 'Цена';
  }

  const suffix = isPricePerMeter ? ' за м²' : '';

  // Оба значения заданы
  if (hasGte && hasLte) {
    const gteFormatted = formatPriceValue(gteNum);
    const lteFormatted = formatPriceValue(lteNum);

    // Если диапазон начинается на миллионах, а заканчивается на миллиардах - считаем в миллионах
    if (gteFormatted.unit === 'млн' && lteFormatted.unit === 'млрд') {
      const lteInMillions = (lteNum / 1000000).toLocaleString('ru-RU');

      return `${gteFormatted.value}–${lteInMillions} млн ₽${suffix}`;
    }

    // Если единицы совпадают
    if (gteFormatted.unit === lteFormatted.unit) {
      return `${gteFormatted.value} — ${lteFormatted.value} ${gteFormatted.unit} ₽${suffix}`;
    }

    // Разные единицы - показываем обе
    return `${gteFormatted.value} ${gteFormatted.unit || '₽'} — ${lteFormatted.value} ${lteFormatted.unit} ₽${suffix}`;
  }

  // Только минимум
  if (hasGte) {
    const formatted = formatPriceValue(gteNum);

    return `От ${formatted.value} ${formatted.unit} ₽${suffix}`;
  }

  // Только максимум
  const formatted = formatPriceValue(lteNum);

  return `До ${formatted.value} ${formatted.unit} ₽${suffix}`;
};
